import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { AppActions } from '../../redux/AppActions';
import './index.scss';
import { ErrorState } from '../../redux/AppReducer';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import { useAppDispatch } from '../../redux/store';
import { ProgressComponent } from '../UI/ProgressComponent/ProgressComponent';
interface IGeneralErrorComponentProps {
	open: boolean;
	error?: ErrorState;
}

export const GeneralErrorComponent: FC<IGeneralErrorComponentProps> = ({ open, error }) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const clearGeneralError = useCallback(() => {
		dispatch(AppActions.setGeneralError({ hasError: false }));
		navigate('/');
	}, [dispatch, navigate]);

	const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
	const [count, setCount] = useState<number>(0);

	useEffect(() => {
		if (intervalId) {
			clearInterval(intervalId);
			setIntervalId(null);
		}

		if (error?.type === 'TokenError') {
			const newIntervalId = setInterval(() => {
				setCount(prevCount => prevCount + 1);
			}, 100);

			setIntervalId(newIntervalId);
		}

		return () => {
			if (intervalId) {
				clearInterval(intervalId);
				setIntervalId(null);
			}
		};
	}, [error?.type]);

	if (!open) return null;
	return (
		<>
			{error?.type === 'TokenError' ? (
				<div className='loader-container error'>
					<ProgressComponent progress={count} max={100} />
				</div>
			) : (
				<div data-testid='error-container' className='error-container'>
					<div>
						<img src={error?.errorImg} alt='error' className='error-img' />
						<div className='error-title-container'>
							<h3 className='error-title'>{error?.errorTitle}</h3>
						</div>
						<p className='error-content'>{error?.errorContent}</p>
						<p className='error-sub-content'>{error?.errorSubContent}</p>
						<div className='error-btn-continer'>
							<ButtonComponent
								style='rounded-button secondary'
								text='Go To Homepage'
								onClick={clearGeneralError}
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
